import type * as React from 'react';

import { Description, type IconDefinition, Label, renderIcon } from '@gitbook/spine-react';

/**
 * Actions in a form.
 */
export function FormButton(props: {
    label: React.ReactNode;
    labelDescription?: React.ReactNode;
    labelSelectable?: boolean;

    /**
     * Optional badge displayed after the label
     */
    badge?: React.ReactNode;

    /** Icon rendered on the left side */
    icon?: IconDefinition;
    children?: React.ReactNode;
}): React.ReactElement {
    const { label, labelDescription, badge, labelSelectable, icon, children } = props;
    return (
        <div className="flex flex-col items-start gap-x-4 gap-y-2 md:flex-row md:items-center">
            {icon ? renderIcon(icon, { size: 20, className: 'text-muted mr-4' }) : null}
            <div className="flex flex-1 flex-col gap-1">
                <div className="flex items-center gap-2">
                    <Label className={labelSelectable ? 'select-all' : undefined}>{label}</Label>
                    {badge}
                </div>
                {labelDescription ? (
                    <Description className={labelSelectable ? 'select-all' : undefined}>
                        {labelDescription}
                    </Description>
                ) : null}
            </div>
            {children}
        </div>
    );
}
